// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3We6X","empty":"ModalGraph_empty__2S91b"};